// extracted by mini-css-extract-plugin
module.exports = {"buttonFillPrimary":"styles_buttonFillPrimary__db5vw","white":"styles_white__gj_el"};